(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grand-flower-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const elementName = 'gf-premium-hero';
  if (customElements.get(elementName)) return;

  class GFPremiumHero extends HTMLElement {
    constructor() {
      super();
      this.slides = [];
      this.dots = [];
      this.activeIndex = 0;
      this.timer = 0;
      this.visible = true;
      this.hovered = false;
      this.ignoreHoverUntilLeave = false;
      this.keyboardFocus = false;
      this.sectionSelected = false;
      this.blockSelected = false;
      this.lastPointerAt = -Infinity;
      this.pointerStart = null;
      this.destroyed = false;
      this.abortController = null;
      this.intersectionObserver = null;
      this.motionQuery = null;
    }

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.destroyed = false;
      this.visible = true;
      this.hovered = false;
      this.ignoreHoverUntilLeave = false;
      this.keyboardFocus = false;
      this.sectionSelected = false;
      this.blockSelected = false;

      this.slides = Array.from(this.querySelectorAll('[data-gf-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-gf-dot]'));
      this.previousButton = this.querySelector('[data-gf-prev]');
      this.nextButton = this.querySelector('[data-gf-next]');
      this.liveRegion = this.querySelector('[data-gf-live]');
      if (!this.slides.length) return;

      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Math.max(Number(this.dataset.autoplaySpeed) || 5000, 3000);
      this.pauseOnHover = this.dataset.pauseHover === 'true';
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reduceMotion = this.motionQuery.matches;
      this.style.setProperty('--gf-autoplay-duration', `${this.autoplaySpeed}ms`);

      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.addEventListener('pointerdown', (event) => this.handlePointerDown(event), { signal });
      this.addEventListener('pointerup', (event) => this.handlePointerUp(event), { signal });
      this.addEventListener('pointercancel', () => this.clearPointer(), { signal });

      this.previousButton?.addEventListener('click', (event) => {
        this.prepareManualInteraction(event);
        this.show(this.activeIndex - 1, { restart: true, announce: true });
      }, { signal });

      this.nextButton?.addEventListener('click', (event) => {
        this.prepareManualInteraction(event);
        this.show(this.activeIndex + 1, { restart: true, announce: true });
      }, { signal });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', (event) => {
          const index = Number(dot.dataset.slideIndex);
          if (!Number.isInteger(index)) return;
          this.prepareManualInteraction(event);
          this.show(index, { restart: true, announce: true });
        }, { signal });
      });

      this.querySelectorAll('[data-gf-copy]').forEach((button) => {
        button.addEventListener('click', async (event) => {
          this.prepareManualInteraction(event);
          await this.copyPromo(button);
          this.restart();
        }, { signal });
      });

      this.addEventListener('mouseenter', () => {
        this.hovered = true;
        this.ignoreHoverUntilLeave = false;
        if (this.pauseOnHover) this.stop();
      }, { signal });

      this.addEventListener('mouseleave', () => {
        this.hovered = false;
        this.ignoreHoverUntilLeave = false;
        this.restart();
      }, { signal });

      this.addEventListener('focusin', () => {
        if (this.isRecentPointerInteraction()) {
          this.keyboardFocus = false;
          return;
        }
        this.keyboardFocus = true;
        this.stop();
      }, { signal });

      this.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!this.isConnected) return;
          this.keyboardFocus = this.contains(document.activeElement) && !this.isRecentPointerInteraction();
          this.restart();
        }, 0);
      }, { signal });

      this.addEventListener('keydown', (event) => {
        this.lastPointerAt = -Infinity;
        this.keyboardFocus = true;
        this.stop();

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.show(this.activeIndex - 1, { announce: true });
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.activeIndex + 1, { announce: true });
        }
      }, { signal });

      document.addEventListener('keydown', () => {
        this.lastPointerAt = -Infinity;
      }, { capture: true, signal });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.stop();
        else this.restart();
      }, { signal });

      this.motionQuery.addEventListener('change', (event) => {
        this.reduceMotion = event.matches;
        if (this.reduceMotion) this.stop();
        else this.restart();
      }, { signal });

      document.addEventListener('shopify:section:select', (event) => {
        if (!this.matchesSectionEvent(event)) return;
        this.sectionSelected = true;
        this.stop();
      }, { signal });

      document.addEventListener('shopify:section:deselect', (event) => {
        if (!this.matchesSectionEvent(event)) return;
        this.sectionSelected = false;
        this.blockSelected = false;
        this.restart();
      }, { signal });

      document.addEventListener('shopify:block:select', (event) => {
        const slide = this.slideFromBlockEvent(event);
        if (!slide) return;
        this.blockSelected = true;
        this.show(Number(slide.dataset.slideIndex), { announce: false });
        this.stop();
      }, { signal });

      document.addEventListener('shopify:block:deselect', (event) => {
        if (!this.slideFromBlockEvent(event)) return;
        this.blockSelected = false;
        this.restart();
      }, { signal });

      if ('IntersectionObserver' in window) {
        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting && entry.intersectionRatio > 0;
          if (this.visible) this.restart();
          else this.stop();
        }, { threshold: 0.2 });
        this.intersectionObserver.observe(this);
      }

      this.show(0);
      this.restart();
    }

    disconnectedCallback() {
      this.destroyed = true;
      this.stop();
      this.abortController?.abort();
      this.intersectionObserver?.disconnect();
      this.clearPointer();
      this.dataset.initialized = 'false';
    }

    normalize(index) {
      return (Number(index) + this.slides.length) % this.slides.length;
    }

    isRecentPointerInteraction() {
      return performance.now() - this.lastPointerAt < 1200;
    }

    prepareManualInteraction(event) {
      const pointerInteraction = this.isRecentPointerInteraction() || event.detail > 0;
      if (!pointerInteraction) return;
      this.keyboardFocus = false;
      this.ignoreHoverUntilLeave = true;
    }

    canAutoplay() {
      const hoverPaused = this.pauseOnHover && this.hovered && !this.ignoreHoverUntilLeave;
      return this.autoplay
        && !this.reduceMotion
        && this.slides.length > 1
        && this.visible
        && !document.hidden
        && !hoverPaused
        && !this.keyboardFocus
        && !this.sectionSelected
        && !this.blockSelected
        && !this.destroyed;
    }

    restart() {
      this.stop();
      if (!this.canAutoplay()) return;
      this.dataset.running = 'true';
      this.restartProgress();
      this.timer = window.setTimeout(() => {
        this.show(this.activeIndex + 1);
        this.restart();
      }, this.autoplaySpeed);
    }

    stop() {
      window.clearTimeout(this.timer);
      this.timer = 0;
      this.dataset.running = 'false';
    }

    restartProgress() {
      const progress = this.dots[this.activeIndex]?.querySelector('.gf-hero-v7__dot-progress');
      if (!progress) return;
      progress.style.animation = 'none';
      void progress.offsetWidth;
      progress.style.animation = '';
    }

    show(index, { restart = false, announce = false } = {}) {
      this.activeIndex = this.normalize(index);

      this.slides.forEach((slide, slideIndex) => {
        const active = slideIndex === this.activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) slide.removeAttribute('inert');
        else slide.setAttribute('inert', '');
      });

      this.dots.forEach((dot, dotIndex) => {
        const active = dotIndex === this.activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      if (announce && this.liveRegion) {
        this.liveRegion.textContent = '';
        window.requestAnimationFrame(() => {
          if (!this.liveRegion) return;
          this.liveRegion.textContent = this.slides[this.activeIndex]?.dataset.slideAnnouncement || '';
        });
      }

      if (restart) this.restart();
    }

    handlePointerDown(event) {
      this.lastPointerAt = performance.now();
      if (event.pointerType === 'mouse' || event.target.closest('a, button')) return;
      this.pointerStart = {
        id: event.pointerId,
        x: event.clientX,
        y: event.clientY
      };
      this.setPointerCapture?.(event.pointerId);
    }

    handlePointerUp(event) {
      if (!this.pointerStart || this.pointerStart.id !== event.pointerId) return;
      const deltaX = event.clientX - this.pointerStart.x;
      const deltaY = event.clientY - this.pointerStart.y;
      this.clearPointer(event.pointerId);
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      this.keyboardFocus = false;
      this.ignoreHoverUntilLeave = true;
      this.show(deltaX < 0 ? this.activeIndex + 1 : this.activeIndex - 1, {
        restart: true,
        announce: true
      });
    }

    clearPointer(pointerId) {
      if (pointerId !== undefined && this.hasPointerCapture?.(pointerId)) {
        this.releasePointerCapture(pointerId);
      }
      this.pointerStart = null;
    }

    matchesSectionEvent(event) {
      const sectionId = String(event.detail?.sectionId || '');
      if (sectionId && sectionId === String(this.dataset.sectionId)) return true;
      return event.target === this || event.target?.contains?.(this) || this.contains(event.target);
    }

    slideFromBlockEvent(event) {
      const blockId = String(event.detail?.blockId || '');
      if (blockId) {
        const slide = this.slides.find((item) => String(item.dataset.blockId) === blockId);
        if (slide) return slide;
      }
      return event.target?.closest?.('[data-gf-slide]') || null;
    }

    async copyPromo(button) {
      const code = button.dataset.code || '';
      const label = button.querySelector('[data-gf-copy-text]');
      if (!code || !label) return;

      const initialText = button.dataset.copyLabel || label.textContent || '';
      const copiedText = button.dataset.copiedLabel || initialText;

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(code);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = code;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          textarea.remove();
        }

        label.textContent = copiedText;
        button.classList.add('is-copied');
        window.setTimeout(() => {
          if (!button.isConnected) return;
          label.textContent = initialText;
          button.classList.remove('is-copied');
        }, 1800);
      } catch (error) {
        console.warn('Grand Flower hero: promo code could not be copied.', error);
      }
    }
  }

  customElements.define(elementName, GFPremiumHero);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
